<template>
<div id="file-import-card">
  <div @click="file_import_dialog = true">
      <slot name="button">
      Import file
      </slot>
  </div>
  <v-dialog v-model="file_import_dialog" :max-width="max_dialog_width">
    <v-card style="border-radius: 8px; display: flex; flex-wrap: wrap; justify-content: center" elevation="0">
      <v-card-title>
        {{ $i18n.t('pages.vehicles_lists.data_import.title') }}
      </v-card-title>
      <v-card-text>
          <div
              v-if="data_is_loaded === false"
              class="import-drop-area-wrapper"
              style="display: flex; justify-content: center; align-items: center"
          >
            <div v-if="data_loading === false"
              @dragenter="drag_enter"
              @dragover="drag_over"
              @dragleave="drag_leave"
              @drop="drop"

              @click="$refs.file_input_ref.click()"
              tabindex="0"
              :title="$i18n.t('pages.vehicles_lists.data_import.click_or_drop_file_here')"
              class="pa-2 import-drop-area"
            >
              <div>{{$i18n.t('pages.vehicles_lists.data_import.click_or_drop_file_here')}}</div>
              <v-icon large style="padding-top: 5px">mdi-cloud-upload</v-icon>
              <input
                @change="select_and_load_file"
                ref="file_input_ref"
                type="file"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                style="display:none"
              />
            </div>
            <v-progress-circular
              v-else
              :size="70"
              color="primary"
              indeterminate
            />
          </div>
        <div v-else>
          <v-tabs v-model="current_tab_index" style="margin-top: 15px;" background-color="transparent">
            <v-tab><span class="tab-font">{{ $i18n.t('pages.vehicles_lists.whitelist') }}</span></v-tab>
            <v-tab><span class="tab-font">{{ $i18n.t('pages.vehicles_lists.blacklist') }}</span></v-tab>

            <v-tab-item key="whitelist" class="rounded_8px">
                <v-card style="border-radius: 8px" id="whitelist_card">
                  <v-card-text>
                    <v-data-table
                      style="letter-spacing: 0.25px;"
                      dense
                      :headers="whitelist_headers"
                      :items="parsed_data.whitelist_cars"
                      :items-per-page="20"
                      :footer-props="{
                      itemsPerPageText: $i18n.t('table_footers.rows_per_page'),
                      itemsPerPageOptions: [5, 10, 15],
                      }"
                      :custom-sort="vehicles_list_sort"
                    >
                      <template #footer.page-text="props">
                      {{ $i18n.t('table_footers.some_rows_of_all', {some: `${props.pageStart}-${props.pageStop}`, all: `${props.itemsLength}`})}}
                      </template>

                      <template v-slot:item.license_plate="{item}">
                        <v-chip outlined color="#207EA9" style="height: 24px;
                                                                box-sizing: border-box;
                                                                border-radius: 8px;
                                                                width: 105px;
                                                                display: flex; justify-content: center"
                        >
                          <span style="color: black">{{item.license_plate}}</span>
                        </v-chip>
                      </template>
                      <template v-slot:item.owner_fio="{item}">
                        {{item.owner_fio}}
                      </template>
                      <template v-slot:item.pass_type="{item}">
                        {{$i18n.t(`pages.vehicles_lists.pass_types.${item.pass_type}`)}}
                      </template>
                      <template v-slot:item.access_start_datetime="{item}">
                        {{ item.access_start_datetime | json_datetime_to_readable_str(item.access_start_datetime)}}
                      </template>
                      <template v-slot:item.access_expiration_datetime="{item}">
                        {{ item.access_expiration_datetime | json_datetime_to_readable_str(item.access_expiration_datetime)}}
                      </template>
                      <template v-slot:item.access_by_datetime_granted="{item}">
                        <div>
                          <span v-if="item.access_by_datetime_granted"
                              style="height: 20px;
                                     width: 20px;
                                     background-color: #9c6;
                                     border-radius: 20px;
                                     display: inline-block;"
                          >
                          </span>
                          <span v-else
                                style="height: 20px;
                                       width: 20px;
                                       background-color: #fa4848;
                                       border-radius: 20px;
                                       display: inline-block;"
                          >
                          </span>
                        </div>
                      </template>
                      <template v-slot:item.actions="{item}">
                        <div style="display: flex; justify-content: flex-end">
                          <vehicles-list-item-editor
                              :list_name="'whitelist'"
                              :addressees="addressees"
                              :requests_to_server="false"
                              :car="item"
                              :car_index="parsed_data.whitelist_cars.indexOf(item)"
                              @edit_vehicles_lists="edit_parsed_list"
                          >
                            <template v-slot:button>
                              <v-btn icon ><v-icon>$icon_edit</v-icon></v-btn>
                            </template>
                          </vehicles-list-item-editor>
                          <v-btn icon>
                            <v-btn icon @click="delete_car(item)"><v-icon>$icon_trash</v-icon></v-btn>
                          </v-btn>
                        </div>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
            </v-tab-item>

            <v-tab-item key="blacklist" class="rounded_8px">
                <v-card style="border-radius: 8px" class="rounded_8px" id="blacklist_card">
                  <v-card-text>
                    <v-data-table
                      :headers="blacklist_headers"
                      :items="parsed_data.blacklist_cars"
                      :items-per-page="20"
                      dense
                      :footer-props="{
                      itemsPerPageText: $i18n.t('table_footers.rows_per_page'),
                      itemsPerPageOptions: [5, 10, 15],
                      }"
                    >
                      <template #footer.page-text="props">
                      {{ $i18n.t('table_footers.some_rows_of_all', {some: `${props.pageStart}-${props.pageStop}`, all: `${props.itemsLength}`})}}
                      </template>
                      <template v-slot:item.license_plate="{item}">
                        <v-chip
                         outlined color="#207EA9"
                         style="height: 24px;
                                box-sizing: border-box;
                                border-radius: 8px;
                                width: 105px;
                                display: flex; justify-content: center"
                         >
                            <span style="color: black">{{item.license_plate}}</span>
                         </v-chip>
                      </template>
                      <template v-slot:item.owner_fio="{item}">
                        {{item.owner_fio}}
                      </template>
                      <template v-slot:item.actions="{item}">
                        <div v-if="item.source !== 'external'" style="display: flex; justify-content: flex-end">
                          <vehicles-list-item-editor
                            :list_name="'blacklist'"
                            :addressees="addressees"
                            :requests_to_server="false"
                            :car="item"
                            :car_index="parsed_data.blacklist_cars.indexOf(item)"
                            @edit_vehicles_lists="edit_parsed_list"
                          >
                            <template v-slot:button>
                              <v-btn icon ><v-icon>$icon_edit</v-icon></v-btn>
                            </template>
                          </vehicles-list-item-editor>
                          <div style="display: flex; justify-content: flex-end">
                            <v-btn icon  @click="delete_car(item)"><v-icon>$icon_trash</v-icon></v-btn>
                          </div>
                        </div>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
            </v-tab-item>
          </v-tabs>
        </div>
        <div style="padding-top: 30px; display: flex; justify-content: space-between">
          <span
              class="button-font"
              style="color: #207ea9"
              @click="get_link_to_example_file"
          >
           {{$i18n.t('pages.vehicles_lists.data_import.download_example_file')}}
          </span>
          <div>
            <v-btn v-if="data_is_loaded === true"
                class="white--text width-170 mr-1"
                height="42"
                color="#DBEAF1"
                elevation="0"
                @click="clear_import_menu_items"
            >
              <span class="button-font main_color">{{ $i18n.t('general.cancel') }}</span>
            </v-btn>
            <v-btn v-if="data_is_loaded === true"
                class="white--text width-170 ml-1"
                height="42"
                color="#207ea9"
                elevation="0"
                @click="import_data_to_db"
            >
              <span class="button-font">{{ $i18n.t('general.save') }}</span>
            </v-btn>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
import {mapActions} from "vuex";
import VehiclesListItemEditor from './VehiclesListItemEditor'
import {i18n} from "@/i18n";
// import moment from 'moment'
import 'moment-timezone'
import {date_time_converters} from "@/mixins/date_time_converters";
import {custom_table_filters} from "@/mixins/custom_table_filters";
import {custom_table_sorts} from "@/mixins/custom_table_sorts";

export default {
name: "FileImport",
  props: ['addressees'],
  components: {
    VehiclesListItemEditor,
  },
  mixins: [date_time_converters, custom_table_filters, custom_table_sorts],
  data: function () {
    return {
      file_import_dialog: false,
      dragover: false,
      selected_file: null,
      default_width: '420px',
      wide_width: '80%',
      max_dialog_width: '420px',
      data_loading: false,
      data_is_loaded: false,
      current_tab_index: 0,
      parsed_data: {
        whitelist_cars: [],
        blacklist_cars: [],
      },
      lists_translations: {
        blacklist: i18n.t('pages.vehicles_lists.blacklist'),
        whitelist: i18n.t('pages.vehicles_lists.whitelist'),
        known: i18n.t('pages.vehicles_lists.known'),
        unknown: i18n.t('pages.vehicles_lists.unknown')
      },
      whitelist_headers: [
            {text: i18n.t('pages.vehicles_lists.table.headers.license_plate'), value: 'license_plate', sortable: false, align: 'start'},
            {text: i18n.t('pages.vehicles_lists.table.headers.owner_name'), value: 'owner_fio'},
            {text: i18n.t('pages.vehicles_lists.table.headers.pass_type'), value: 'pass_type'},
            {text: i18n.t('pages.vehicles_lists.table.headers.access_start_date'), value: 'access_start_datetime'},
            {text: i18n.t('pages.vehicles_lists.table.headers.access_expiration_date'), value: 'access_expiration_datetime'},
            {text: i18n.t('pages.vehicles_lists.table.headers.access_granted'), value: 'access_by_datetime_granted'},
            {text: i18n.t('pages.vehicles_lists.table.headers.actions'), align: 'end', value: 'actions', sortable: false}
        ],
        blacklist_headers: [
            {text: i18n.t('pages.vehicles_lists.table.headers.license_plate'), value: 'license_plate', sortable: false, align: 'start'},
            {text: i18n.t('pages.vehicles_lists.table.headers.owner_name'), value: 'owner_fio'},
            {text: i18n.t('pages.vehicles_lists.table.headers.actions'), align: 'end', value: 'actions', sortable: false}
        ],
    }
  },
  methods: {
    files_selected() {
      console.log(this.selected_file)
      this.dragover = false
      this.get_data_from_file()
    },
    drag_enter: function (e) {
      e.preventDefault()
      this.dragover = true
    },
    drag_leave: function (e) {
      e.preventDefault()
      this.dragover = false
    },
    drag_over: function (e) {
      e.preventDefault()
      this.dragover = true
    },
    drop: function (e) {
      e.preventDefault()
      console.log(e)
      this.selected_file = e.dataTransfer.files[0]
      this.files_selected()
    },
    get_link_to_example_file: function () {
      this.$http({url: this.$http_hostname + '/vehicles_lists/example_file', method: 'GET'})
      .then(resp => {
        this.updateLoadingOverlay({is_loading: false})
        this.download_example_file(resp.data.link)
      })
      .catch(error => {
        console.log(error)
      })
    },
    download_example_file: function (link) {
      window.open(this.$http_hostname + link, '_blank')
    },
    select_and_load_file: function (e) {
      this.selected_file = e.target.files[0]
      this.get_data_from_file()
    },
    get_data_from_file: function () {
      this.data_loading = true
      let t = this
      let formData = new FormData();
      formData.append('excel_file', this.selected_file);
      this.$http({
        url: this.$http_hostname + '/vehicles_lists/parse_vehicles_lists_file',
        data: formData,
        headers: {'Content-Type': 'multipart/form-data' },
        method: 'POST'})
      .then(resp => {
        t.max_dialog_width = this.wide_width
        resp.data.parsed_data.forEach((car) => {
          if (car['access_type'] === 'whitelist') {
            t.parsed_data.whitelist_cars.push(car)
          }
          if (car['access_type'] === 'blacklist') {
            t.parsed_data.blacklist_cars.push(car)
          }
          t.data_is_loaded = true
        })
      })
      .catch(error => {
        console.log(error)
        this.setSnackbar({
          text: i18n.t('notifications.error_during_data_loading')
        })
      })
    },

    clear_import_menu_items: function () {
      this.dragover = false
      this.selected_file = null
      this.max_dialog_width = this.default_width
      this.data_loading = false
      this.data_is_loaded = false
      this.parsed_data = {
        whitelist_cars: [],
        blacklist_cars: []
      }
    },
    /*
    json_datetime_to_time_str: function (datetime) {
      if (!datetime) return '...'
      return moment(datetime['$date']).tz(this.$store.state.current_system_timezone).format('HH:mm')
    },
    */
    /*
    json_datetime_to_slash_date: function (datetime) {
      if (!datetime) return
      return moment(datetime['$date']).tz(this.$store.state.current_system_timezone).startOf('day').format('DD/MM/YYYY')
    },
    */
    edit_parsed_list: function (params) {
      if (params.car_index > -1) {
        if (params.list === 'whitelist') {
          if (params.access_type_was_changed) {
            this.parsed_data.blacklist_cars.splice(params.car_index, 1)
            this.parsed_data.whitelist_cars.push(params.car)
          } else {
            Object.assign(this.parsed_data.whitelist_cars[params.car_index], params.car)
          }
        } else if (params.list === 'blacklist') {
          if (params.access_type_was_changed) {
            this.parsed_data.whitelist_cars.splice(params.car_index, 1)
            this.parsed_data.blacklist_cars.push(params.car)
          } else {
            Object.assign(this.parsed_data.blacklist_cars[params.car_index], params.car)
          }
        }
      }
    },
    edit_vehicles_list: function (params) {
        if (params.car_index > -1) {
        //  Car was edited
          let old_list = params.old_list
          let new_list = params.car.access_type
          if (new_list === 'whitelist') {
            if (params.old_list !== params.car.access_type) {
              if (old_list === 'blacklist') this.parsed_data.blacklist_cars.splice(params.car_index, 1)
              else if (old_list === 'known') this.parsed_data.known_cars.splice(params.car_index, 1)
              this.parsed_data.whitelist_cars.push(params.car)
            } else {
              Object.assign(this. parsed_data.whitelist_cars[params.car_index], params.car)
            }
          } else if (new_list === 'blacklist') {
            if (params.old_list !== params.car.access_type) {
              if (old_list === 'whitelist') this.parsed_data.whitelist_cars.splice(params.car_index, 1)
              else if (old_list === 'known') this.parsed_data.known_cars.splice(params.car_index, 1)
              this.parsed_data.blacklist_cars.push(params.car)
            } else {
              Object.assign(this.parsed_data.blacklist_cars[params.car_index], params.car)
            }
          } else if (new_list === 'known') {
            if (params.old_list !== params.car.access_type) {
              console.log("Warning: Trying to EDIT permit with status 'known' (!)")
            }
            else {
              Object.assign(this.parsed_data.known_cars[params.car_index], params.car)
            }
          }
        }
      },

    delete_car: function (car) {
      let delete_confirm = confirm(i18n.t('submissions.delete_plate', {plate: car.license_plate, list_name: this.lists_translations[car.access_type]}))
      if (delete_confirm) {
        if (car.access_type === 'blacklist') {this.parsed_data.blacklist_cars.splice(this.parsed_data.blacklist_cars.indexOf(car), 1)}
        if (car.access_type === 'whitelist') {this.parsed_data.whitelist_cars.splice(this.parsed_data.whitelist_cars.indexOf(car), 1)}
      }
    },

    import_data_to_db: function () {
      let edited_data = this.parsed_data.whitelist_cars.concat(this.parsed_data.blacklist_cars)
      let data = {'edited_data': edited_data}
      this.$http({url: this.$http_hostname + '/vehicles_lists/import_vehicles_lists_data', data: data, method: 'POST'})
      .then(resp => {
        let new_cars_inner_ids = resp.data.new_cars_inner_ids
        edited_data.forEach((car, car_index, edited_data) => {
        edited_data[car_index].inner_id = new_cars_inner_ids.shift()
        })
        this.$emit('load_data_from_parser', {new_data: edited_data})
        this.file_import_dialog = false
      })
      .catch(error => {
        console.log(error)
      })

    },
    ...mapActions(['setSnackbar', 'updateLoadingOverlay'])
  },

  mounted () {
  },

  watch: {
  file_import_dialog (val) {
      !val && this.clear_import_menu_items()
    },
  }
}
</script>

<style scoped>
.import-drop-area-wrapper {
  height: 150px;
}
.import-drop-area {
  border: 2px dashed #aaa;
  background-color: #eee;
  text-align: center;
  color: #888;
  width: 100%;
  height: 100%;
  cursor: pointer;
  font-size: 1.5rem;
}
</style>